import React from 'react'

const MissingRoute = () => {
   window.location.href = "/school-dashboard/dashboard"
   return (<div></div>)
}

export default MissingRoute